module.exports = __webpack_public_path__ + "static/media/wash-press-service-icon.0fa81928.svg";